/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RemoveVehiclesRequestBody } from '../../models/remove-vehicles-request-body';

export interface UserRemoveVehicles$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The object ID. Must be a valid ID.
 */
  userUid: string;
      body: RemoveVehiclesRequestBody
}

export function userRemoveVehicles(http: HttpClient, rootUrl: string, params: UserRemoveVehicles$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, userRemoveVehicles.PATH, 'post');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.path('userUid', params.userUid, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

userRemoveVehicles.PATH = '/subscriptions/{uid}/users/{userUid}/vehicles/remove';
